// create history
const history = require('umi/lib/createHistory').default({
  basename: window.routerBase,
});
export default history;
